import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=4aaa26e6&"
import script from "./CharacterDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aaa26e6')) {
      api.createRecord('4aaa26e6', component.options)
    } else {
      api.reload('4aaa26e6', component.options)
    }
    module.hot.accept("./CharacterDetail.vue?vue&type=template&id=4aaa26e6&", function () {
      api.rerender('4aaa26e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CharacterDetail.vue"
export default component.exports